<template>
  <div class="relative min-h-screen overflow-hidden">
    <div class="pointer-events-none absolute inset-0 tech-grid opacity-25" />
    <header class="sticky top-0 z-50 border-b border-[var(--border)] bg-[var(--bg)]/90 backdrop-blur">
      <Navbar />
    </header>

    <main class="relative z-10">
      <transition
        enter-active-class="transition-all duration-500 ease-out"
        leave-active-class="transition-all duration-300 ease-in"
        enter-from-class="opacity-0 translate-y-3"
        enter-to-class="opacity-100 translate-y-0"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 -translate-y-2"
        mode="out-in"
      >
        <router-view />
      </transition>
    </main>

    <FooterComponent />

    <div class="fixed bottom-5 right-5 z-[60]">
      <button
        type="button"
        class="flex items-center gap-2 rounded-full border border-[var(--border)] bg-[var(--panel)]/90 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--text-muted)] shadow-lg transition hover:text-[var(--accent)]"
        @click="toggleLocale"
      >
        <span class="rounded-full bg-[var(--accent)] px-2 py-1 text-[#050709]">{{ currentLocale.toUpperCase() }}</span>
        <span>{{ $t('language.toggle') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import FooterComponent from "./components/FooterComponent.vue";

export default {
  name: "AppShell",
  components: { Navbar, FooterComponent },
  computed: {
    currentLocale() {
      return this.$i18n?.locale?.value ?? this.$i18n?.locale;
    },
  },
  methods: {
    setLocale(locale) {
      if (this.$i18n?.locale?.value !== undefined) {
        this.$i18n.locale.value = locale;
      } else if (this.$i18n) {
        this.$i18n.locale = locale;
      }
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('preferredLocale', locale);
      }
      const titleKey = this.$route?.meta?.titleKey;
      if (titleKey) {
        document.title = `Christopher-William | ${this.$t(titleKey)}`;
      }
    },
    toggleLocale() {
      const nextLocale = this.currentLocale === 'fr' ? 'en' : 'fr';
      this.setLocale(nextLocale);
    },
  },
};
</script>
